const PRODUCTION_API_BASE_URL = 'https://api.liwaza.org';
const PRODUCTION_API_SOCKET_URL = 'wss://api.liwaza.org';
export const PRODUCTION_GOOGLE_CLIENT_ID =
  '539165127943-oe4t7re03ph67i1foblrjhe75tt79s5r.apps.googleusercontent.com';

const PRODUCTION_FRONTEND_HOSTS = new Set([
  'app.liwaza.org',
  'app-liwaza-c.web.app',
  'app-liwaza-c.firebaseapp.com',
  'app-liwaza.web.app',
  'app-liwaza.firebaseapp.com',
]);

const trimEnv = (value) => String(value || '').trim().replace(/^['"]|['"]$/g, '');

export const currentFrontendHostname = () =>
  typeof window !== 'undefined' ? window.location?.hostname : undefined;

export const isProductionFrontendHost = (
  hostname = currentFrontendHostname()
) => Boolean(hostname && PRODUCTION_FRONTEND_HOSTS.has(hostname));

export const resolveApiBaseUrl = (hostname = currentFrontendHostname()) => {
  const fromEnv = trimEnv(process.env.REACT_APP_API_BASE_URL);
  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }
  if (isProductionFrontendHost(hostname)) {
    return PRODUCTION_API_BASE_URL;
  }
  return `http://${hostname || '127.0.0.1'}:8000`;
};

export const resolveApiSocketUrl = (hostname = currentFrontendHostname()) => {
  const fromEnv = trimEnv(process.env.REACT_APP_API_SOCKET_URL);
  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }
  if (isProductionFrontendHost(hostname)) {
    return PRODUCTION_API_SOCKET_URL;
  }
  return `ws://${hostname || '127.0.0.1'}:8000`;
};

export const resolveGoogleClientId = (hostname = currentFrontendHostname()) => {
  const fromEnv = trimEnv(process.env.REACT_APP_GOOGLE_CLIENT_ID);
  if (fromEnv) {
    return fromEnv;
  }
  if (isProductionFrontendHost(hostname)) {
    return PRODUCTION_GOOGLE_CLIENT_ID;
  }
  return undefined;
};
